import React, { Component } from 'react';
import DashboardView from '../components/views/DashboardView';
import DataGrid from '../components/DataGrid';
import TemplatesData from './TemplatesData';
import { nanoid } from 'nanoid';
import Responsive from '../components/Responsive';
import CustomLoader from '../components/CustomLoader';
import { translate } from '../utils/useful';

class TemplatesPreview extends Component {

    state = {}

    componentDidMount() {
        console.log('previewData', this.props.previewData)
    }

    render() {
        let data = this.props.data
        let previewData = this.props.previewData
        let index = this.props.previewNum
        return (
            <div className="h-100  w-100  scroll-no-scrollbar" style={{ background: '#fff' }}>
                <div className='flexc py-3 px-2' style={{ borderBottom: '1px solid #eee' }}>
                    <button className='flexcc' onClick={() => { this.props.changePage('tempalesView') }}>
                        <img src='/assets/icons/back-black.svg' />
                    </button>
                    <p className='font-size-14 main-c2' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{previewData.title}</p>
                    <p className='mld-2 px-2 py-1' style={{ background: '#5b65f533', color: '#4752e6', borderRadius: '4px', fontSize: '12px' }}>{translate('Template')}</p>
                </div>
                <div className='w-100 px-5 py-4'>
                    <p className='weight-700 font-size-25 pb-4'>{previewData.title}</p>
                    <div className='pld-4 flexc py-1' style={{ borderLeft: '2px solid #e2e2e2' }}>
                        <p className='font-size-14' style={{ color: '#646a73', lineHeight: '22px' }}>A sequence diagram is a type of UML diagram that shows the process interactions for a group of objects in a time sequence. It can represent the action sequence of use cases.</p>
                    </div>
                    <div className='mt-3 br-6 flexcc p-1' style={{ border: '1px solid #eee', marginBottom: '60px' }}>
                        <img src={previewData.img} width={'100%'} />
                    </div>
                </div>
                <div className='flexc py-3 px-2 w-100' style={{ position: 'absolute', bottom: '0px', backgroundColor: '#fff' }}>
                    <button className='br-6 prd-3 py-1 mrd-1 flexcc' style={{ border: '1px solid #222', color: '#222', opacity: index > 0 ? 1 : 0.5 }} onClick={() => index > 0 ? this.props.changePreview(index - 1, data[index - 1]) : {}}>
                        <img src='/assets/icons/back-black.svg' height={'20px'} />
                        <p>Previous</p>
                    </button>
                    <button className='br-6 pld-3 py-1 mld-1 flexcc' style={{ border: '1px solid #222', color: '#222', opacity: index < data.length - 1 ? 1 : 0.5 }} onClick={() => index < data.length - 1 ? this.props.changePreview(index + 1, data[index + 1]) : {}}>
                        <p>Next</p>
                        <img src='/assets/icons/back-black.svg' height={'20px'} style={{ transform: 'rotate(180deg)' }} />
                    </button>
                </div>
            </div>
        );
    }
}

export default TemplatesPreview;